<div *ngIf="isShown()">
    <div class="notification-body">
        <mat-toolbar color="primary">
            <span style="margin: 0 auto;"> Notification Center </span>
        </mat-toolbar>

        <button class= "notification-exit" (click)="toggleVisibility()">
            <mat-icon>close</mat-icon>
        </button>

        <div class="notification-content">
            @for (noti of notifications; track $index) {

            <div [class.notification2]="$index%2==0" [class.notification]="$index%2==1">
                <mat-icon *ngIf='!noti["read"]' class="notification-indicator">circle</mat-icon>

                <button class= "notification-archiver" (click)="archive(noti, $index)">
                    <mat-icon>close</mat-icon>
                </button>

                <div>
                    <p class="notification-text">{{ noti["message"] }}</p>
                </div>

                
                <a *ngIf="!isNotificationLinkInternal(noti)" target="_blank" href='{{noti["reference"]["link"]}}' class="notification-link notification-text">{{
                    noti["reference"]["text"] }}</a>

                <a *ngIf="isNotificationLinkInternal(noti)" (click)="goto(noti)" class="internalLink notification-link notification-text">{{
                    noti["reference"]["text"] }}</a>


                <p class="notification-date notification-text">{{noti["date"].toLocaleString([], {day: 'numeric', month:
                    'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit'}) }}</p>
            
                
        </div>


            
            }
        </div>
    </div>
</div>